import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import UnderstandingReportName, { UnderstandingReportType, } from "@domains/entities/Reports/UnderstandingSection";
import { EmptyValidation, ReportsEnum } from "@domains/utils/commonText";
import { EmptyIcon } from "../action-interfaces/Reports/HoldingReport";
import { TaxErrorEnum, } from "../action-interfaces/Reports/TaxReport";
import { ReportGAEvents } from "@domains/trackers/gtmService";
import { ReportsGTMConstants } from "@domains/aggregates/Reports/ReportsGAConstants";
import { accountDetails } from "@frameworks/web/di";
import { isLoginSourceEMT, triggerDownloadReportCallback, } from "@domains/utils/emtReportCallback";
class TaxReportPresenter {
    constructor(useCases, actions, understandUseCase, downloadPDFReports, downloadExcelReports, sendEmailReports, GTMService, clearTaxUseCase) {
        this.useCases = useCases;
        this.actions = actions;
        this.understandUseCase = understandUseCase;
        this.downloadPDFReports = downloadPDFReports;
        this.downloadExcelReports = downloadExcelReports;
        this.sendEmailReports = sendEmailReports;
        this.GTMService = GTMService;
        this.clearTaxUseCase = clearTaxUseCase;
        this.initTaxReportData = {
            taxSummary: undefined,
            taxDetail: []
        };
        this.TaxReportData = this.initTaxReportData;
        this.abortController = new AbortController();
        this.emailAndDownload = false;
        this.emailList = [];
    }
    updateEmailList(emails) {
        this.emailList = emails;
    }
    getTaxReportData(requestData) {
        this.actions.hideEmptyValidation();
        this.actions.hideError();
        this.actions.getTaxReportData(this.initTaxReportData);
        if (this.abortController.signal)
            this.abortController.abort();
        if (this.abortController.signal.aborted)
            this.abortController = new AbortController();
        this.useCases.execute({
            onSuccess: (data) => {
                this.TaxReportData = data;
                this.actions.getTaxReportData(data);
                if ((data === null || data === void 0 ? void 0 : data.taxDetail.length) <= 0) {
                    const emptyValidation = EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.TAX];
                    this.actions.setEmptyValidation({ emptyValidation });
                }
            },
            onError: (error) => {
                let errorCode = error.getErrorCode();
                if (errorCode !== DOMException.ABORT_ERR.toString() &&
                    typeof error != "undefined") {
                    this.actions.getTaxReportData(this.initTaxReportData);
                    this.actions.setError({
                        error,
                        isOpen: true,
                    }, TaxErrorEnum.ERROR_DATA);
                }
            },
        }, Object.assign(Object.assign({}, requestData), { abortSignal: this.abortController.signal }));
    }
    getTaxUnderstandingSectionData() {
        const payload = {
            reportName: UnderstandingReportName.TAX,
            type: UnderstandingReportType.SUMMARY_FIELD,
        };
        this.understandUseCase.execute({
            onSuccess: (understandSectionData) => {
                if (understandSectionData.reportDetails.length > 0) {
                    this.actions.getTaxUnderstandingSectionData(understandSectionData);
                }
            },
            onError: (error) => {
                this.actions.setErrorUnderStandings({
                    error,
                    isOpen: true,
                });
            },
        }, payload);
    }
    async downloadAndSendReportTax(email, download) {
        this.actions.hideError(TaxErrorEnum.EMAILSTATUS);
        this.actions.hideError(TaxErrorEnum.DOWNLOADSTATUS);
        if (email && download) {
            this.emailList = email.emailIds;
            this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Tax}`, `${ReportsGTMConstants.Download} / ${ReportsGTMConstants.Email}  | ${ReportsGTMConstants.Submit}`));
            this.emailAndDownload = true;
        }
        if (email) {
            this.emailList = email.emailIds;
            this.actions.hideError(TaxErrorEnum.EMAILSTATUS);
            const emailPayload = {
                fromDate: email.fromDate,
                toDate: email.toDate,
                reportType: email.reportType,
                emailIds: email.emailIds,
                reportName: ReportName.TAX,
            };
            if (email === null || email === void 0 ? void 0 : email.taxHarvesting)
                emailPayload.taxHarvesting = email === null || email === void 0 ? void 0 : email.taxHarvesting;
            if (email.urlParts)
                emailPayload.urlParts = email.urlParts;
            if (email.usetaxDPURL)
                emailPayload.usetaxDPURL = email.usetaxDPURL;
            if (email.dpId)
                emailPayload.dpId = email.dpId;
            if (email === null || email === void 0 ? void 0 : email.accodes)
                emailPayload.accodes = email === null || email === void 0 ? void 0 : email.accodes;
            this.emailAndDownload
                ? null
                : this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Tax}`, `${ReportsGTMConstants.Email}  | ${ReportsGTMConstants.Submit}`));
            this.sendEmailReports.execute({
                onSuccess: (data) => {
                    this.actions.setError({
                        isOpen: data,
                        error: null,
                    }, TaxErrorEnum.EMAILSTATUS);
                },
                onError: (error) => {
                    this.actions.setError({
                        isOpen: false,
                        error,
                    }, TaxErrorEnum.EMAILSTATUS);
                },
            }, emailPayload);
        }
        if (download) {
            const loginSource = await accountDetails.getLoginSrc();
            if (download.reportType === ReportType.PDF) {
                const downloadPayload = {
                    subReportName: ReportName.TAX,
                    reportName: ReportName.TAX,
                    fromDate: download.fromDate,
                    toDate: download.toDate,
                };
                if (download === null || download === void 0 ? void 0 : download.taxHarvesting)
                    downloadPayload.taxHarvesting = download === null || download === void 0 ? void 0 : download.taxHarvesting;
                if (download === null || download === void 0 ? void 0 : download.urlParts)
                    downloadPayload.urlParts = download.urlParts;
                if (download === null || download === void 0 ? void 0 : download.usetaxDPURL)
                    downloadPayload.usetaxDPURL = download.usetaxDPURL;
                if (download.dpId)
                    downloadPayload.dpId = download.dpId;
                if (download.dpType)
                    downloadPayload.dpType = download.dpType;
                if (download === null || download === void 0 ? void 0 : download.accodes)
                    downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
                if (download === null || download === void 0 ? void 0 : download.isPwdProtected)
                    downloadPayload.isPwdProtected = download === null || download === void 0 ? void 0 : download.isPwdProtected;
                this.emailAndDownload
                    ? null
                    : this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.PDF}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Tax}`, `${ReportsGTMConstants.Download}  | ${ReportsGTMConstants.Submit}`));
                this.downloadPDFReports.execute({
                    onSuccess: (data) => {
                        this.actions.setError({
                            isOpen: data,
                            error: null,
                        }, TaxErrorEnum.DOWNLOADSTATUS);
                    },
                    onError: (error) => {
                        this.actions.setError({
                            isOpen: false,
                            error,
                        }, TaxErrorEnum.DOWNLOADSTATUS);
                    },
                }, downloadPayload);
            }
            else {
                const downloadPayload = {
                    subReportName: ReportName.TAX,
                    reportName: ReportName.TAX,
                    fromDate: download.fromDate,
                    toDate: download.toDate,
                };
                if (download === null || download === void 0 ? void 0 : download.urlParts)
                    downloadPayload.urlParts = download.urlParts;
                if (download === null || download === void 0 ? void 0 : download.usetaxDPURL)
                    downloadPayload.usetaxDPURL = download.usetaxDPURL;
                if (download.dpId)
                    downloadPayload.dpId = download.dpId;
                if (download.dpType)
                    downloadPayload.dpType = download.dpType;
                if (download === null || download === void 0 ? void 0 : download.accodes)
                    downloadPayload.accodes = download === null || download === void 0 ? void 0 : download.accodes;
                if (download === null || download === void 0 ? void 0 : download.isPwdProtected)
                    downloadPayload.isPwdProtected = download === null || download === void 0 ? void 0 : download.isPwdProtected;
                this.emailAndDownload
                    ? null
                    : this.GTMService.gtmService(new ReportGAEvents(`${ReportsGTMConstants.Download} | ${ReportsGTMConstants.EXCEL}`, `${ReportsGTMConstants.NewReports} | ${ReportsGTMConstants.Tax}`, `${ReportsGTMConstants.Download}  | ${ReportsGTMConstants.Submit}`));
                if (isLoginSourceEMT(loginSource)) {
                    triggerDownloadReportCallback("GET", ReportType.EXCEL, ReportName.TAX, { financialYear: download === null || download === void 0 ? void 0 : download.financialYear }, loginSource);
                }
                else {
                    this.downloadExcelReports.execute({
                        onSuccess: (data) => {
                            this.actions.setError({
                                isOpen: data,
                                error: null,
                            }, TaxErrorEnum.DOWNLOADSTATUS);
                        },
                        onError: (error) => {
                            this.actions.setError({
                                isOpen: false,
                                error,
                            }, TaxErrorEnum.DOWNLOADSTATUS);
                        },
                    }, downloadPayload);
                }
            }
        }
        this.emailAndDownload = false;
    }
    clearTax(req) {
        return new Promise((resolve, reject) => {
            this.clearTaxUseCase.execute({
                onSuccess: (clearTax) => {
                    resolve(clearTax);
                },
                onError: (error) => {
                    reject(error);
                },
            }, req);
        });
    }
}
export default TaxReportPresenter;
